import React from 'react';
import PropTypes from 'prop-types';

// INPUT
import TextFieldGroup from '../../../../../components/common/textFieldGroup/TextFieldGroup';

// VALIDATIONS
import isEmptyVAL from '../../../../../validations/checks/isEmptyVAL';

// UTILITIES
import { outputMasterUTL } from '../../../../../utils/outputMasterUTL';
import { transUTL } from '../../../../../utils/transUTL';

const DriversLicenceIndia = ({
  formState,
  selectedDataSources,
  handleOnChange,
  handleOnBlur,
  handleEnterKeyTrigger,
}) => {
  const { driversLicenceNumber, errors } = formState;

  const inputElements = [
    {
      belongsTo: ['India Drivers Licence'],
      element: (
        <TextFieldGroup
          key="driversLicenceNumber"
          id="driversLicenceNumber"
          type="text"
          name="driversLicenceNumber"
          dataName="driversLicenceNoIN"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.driversLicenceNumber')}
          value={driversLicenceNumber}
          placeholder={transUTL(
            'translatePlaceholder.inputIN.driversLicenceNumber'
          )}
          placeholderTrigger={isEmptyVAL(driversLicenceNumber) ? 'input-empty' : ''}
          error={errors.driversLicenceNumber}
          errorTrigger={errors.driversLicenceNumber ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },
  ];

  return (
    <div className="form-overview__form-inputs">
      {outputMasterUTL(selectedDataSources, inputElements)}
      <span />
    </div>
  );
};

DriversLicenceIndia.propTypes = {
  formState: PropTypes.object.isRequired,
  selectedDataSources: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnBlur: PropTypes.func.isRequired,
  handleEnterKeyTrigger: PropTypes.func.isRequired,
};

export default DriversLicenceIndia;
